module.exports = __webpack_public_path__ + "static/img/home_b_2.85b56103.png";